<div class="d-flex justify-content-center text-selection-none">
  <div class="col-lg-3 col-md-3 col-3 left-panel-menu">
    <div class="card shadow bg-white rounded m-2">
      <h2 class="card-title text-center">Главы</h2>
      <div *ngFor="let chapter of currentCourse.chapters; let k=index" class="card-body chapter-list">
        <h5 class="card-title">{{chapter.title}}</h5>
        <div *ngFor="let topic of chapter.topics; let i=index"
             class="{{selectedTopic._id === topic._id ? 'selected-topic' : ''}} topic">
          <a (click)="topicSelected(i, k, chapter)">
            <span class="number">{{i + 1}}.</span> {{topic.title}}
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="col-lg-8 col-md-9 col-9 p-0 course-content text-selection-none">
    <div class="card shadow bg-white rounded m-2">
      <div class="card-body">
        <h4 class="card-subtitle mb-2 text-center">{{selectedTopic.title}}</h4>
        <div #videoContent class="text-center"></div>
        <div class="col-12">
          <ol>
            <li *ngFor="let video of selectedTopic.videos; let i=index">
              <a (click)="setVideo(i)" class="video-list" data-target="#modalYT" data-toggle="modal">
                <i class="bx bx-right-arrow"></i>
                <p class="{{selectedVideoIndex===i ? 'selected-video' : ''}}">{{video.title}}</p>
              </a>
            </li>
            <li>
              <a (click)="onShowQuiz()" class="video-list" data-target="#pract" data-toggle="modal">
                <i class='bx bx-edit-alt'></i>
                <p> Экзамен </p>
              </a>
            </li>
          </ol>
          <span [innerHTML]="selectedTopic.content"></span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="col-lg-3 col-md-3 col-3 for-mobile-only text-selection-none">
  <div class="card shadow bg-white rounded m-2">
    <h2 class="card-title text-center">Главы</h2>
    <div *ngFor="let chapter of currentCourse.chapters; let k=index;" class="card-body chapter-list">
      <h5 class="card-title">{{chapter.title}}</h5>
      <div *ngFor="let topic of chapter.topics; let i=index"
           class="{{selectedTopic._id === topic._id ? 'selected-topic' : ''}} topic">
        <a (click)="topicSelected(i, k, chapter)">
          <span class="number">{{i + 1}}.</span> {{topic.title}}
        </a>
      </div>
    </div>
  </div>
</div>

<!--Modal: Quiz-->
<div aria-labelledby="myModalLabel" class="modal fade text-selection-none" id="pract" role="dialog">
  <div class="modal-dialog modal-lg" role="document">
    <!--Content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel">Тема: {{selectedTopic.title}}</h4>
        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
          <span aria-hidden="true" style="font-size: 45px; font-weight: 300;"> &times;
          </span>
        </button>
      </div>
      <!--Body-->
      <div class="modal-body">
        <div *ngFor="let test of quiz; let i=index;" [ngClass]="{'active': i==selectedQuestionIndex}" class="carousel-item">
          <span>{{selectedQuestionIndex+1}}) </span>
          <figure *ngIf="test.questionImgUrl" class="image">
            <img src="{{test.questionImgUrl}}">
          </figure>          <span [innerHTML]="test.questionText"></span>

          <span *ngFor="let option of test?.options; let j = index;" class="d-flex">
            <button (click)="onChangeAns(option?.optionText, j)"
                    [id]="'option-'+i.toString()+variants[j]"
                    [class.checked]="ans.index == j" class="option">{{variants[j]}}</button>
            <figure *ngIf="test.options[j].optionImgUrl.length>0" class="image">
                <img src="{{test.options[j].optionImgUrl}}">
            </figure>
            <span [innerHTML]="option.optionText"></span>
          </span>

        </div>
      </div>
      <!--Footer-->
      <div class="modal-footer">
        <div class="nav-btn" id="practice">
          <button (click)="showNextQuestion(i)" *ngFor="let p of quiz; let i = index"
                  [attr.data-slide-to]="i" [id]="'indexButtons-'+i.toString()"
                  [ngClass]="{'active': selectedQuestionIndex==i}" class="btn btn-outline-info"
                  data-target="#practice-carousel"
                  type="button">{{i + 1}}</button>
        </div>
        <div class="buttons-2 d-flex">
          <button (click)="checkTest()" *ngIf="quiz?.length >0" [disabled]="!answerSelected || isCorrect"
                  class="btn btn-outline-primary btn-rounded btn-md ml-4" type="button">Проверить
          </button>
          <button (click)="showNextQuestion(selectedQuestionIndex+1)" *ngIf="selectedQuestionIndex+1 != quiz?.length"
                  class="btn btn-outline-primary btn-rounded btn-md ml-4"
                  data-slide="next" href="#practice-carousel" role="button" type="button">Следующий
          </button>
          <button *ngIf="selectedQuestionIndex == quiz?.length-1"
                  class="btn btn-outline-primary btn-rounded btn-md ml-4"
                  data-dismiss="modal"
                  type="button">Закончить
          </button>
        </div>

      </div>
    </div>
  </div>
</div>
